import styled from 'styled-components';
import { PrimaryButton } from 'components';

export const ErrorMessage = styled.span`
  color: red;
`;

export const DSButton = styled(PrimaryButton)`
  background-color: #ffffff !important;
  border-radius: 2px;
  border: 1.5px solid #000;
  color: #333333;
  margin-top: 15px;
`;

export const DSContent = styled.p`
  position: relative;
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  margin-top: 10px;
  color: #757575;
  padding-bottom: 24px;
  line-height: 150%;
`;
